<template>
    <div
        class="o-t-transport-item"
        @click="changeTransportItem"
    >
        <div class="o-t-transport-item__icon">
            <img
                :alt="$t('ui.terminal.transport_item_icon')"
                :src="item.parentObject.files.icon"
            >
        </div>
        <div class="o-t-transport-item__number">
            {{item.routeId}}
        </div>
        <div class="o-t-transport-item__name">
            {{item.name}}
        </div>
    </div>
</template>

<script>
export default {
    name: 'OTTransportItem',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    methods: {
        changeTransportItem() {
            this.$emit('changeTransportItem', this.item);
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />